// Mirrors the most common entries of the backend's GenericEmailDomainValidator
// for instant client-side feedback. The backend remains the source of truth.

const GENERIC_DOMAINS = new Set([
  // Global webmail
  'gmail.com', 'googlemail.com',
  'yahoo.com', 'ymail.com', 'rocketmail.com',
  'hotmail.com', 'outlook.com', 'live.com', 'msn.com',
  'icloud.com', 'me.com', 'mac.com',
  'aol.com',
  'protonmail.com', 'proton.me', 'pm.me',
  'yandex.com', 'yandex.ru',
  'zoho.com', 'gmx.com', 'gmx.net',
  'mail.com', 'mail.ru',
  'fastmail.com', 'tutanota.com', 'tuta.io',
  'qq.com', '163.com', '126.com', 'sina.com', 'naver.com',
  // Spanish/LatAm webmail variants
  'yahoo.com.ar', 'yahoo.es', 'yahoo.com.mx', 'yahoo.com.br',
  'hotmail.com.ar', 'hotmail.es', 'hotmail.com.mx', 'hotmail.com.br',
  'outlook.com.ar', 'outlook.es',
  'live.com.ar', 'live.com.mx',
  // Argentine ISPs that historically gave free email aliases to subscribers
  'fibertel.com', 'fibertel.com.ar',
  'speedy.com.ar',
  'arnet.com.ar', 'arnet.net.ar',
  'ciudad.com.ar', 'ciudad.com',
  'telecentro.com.ar', 'telecentro.net.ar',
  'gigared.com.ar', 'flash.com.ar',
  // Disposable / temp mail
  'mailinator.com', 'trashmail.com', 'tempmail.com',
  'guerrillamail.com', '10minutemail.com', 'yopmail.com',
  'maildrop.cc', 'sharklasers.com', 'dispostable.com',
  'getairmail.com', 'temp-mail.org',
]);

export const isGenericEmailDomain = (domain) => {
  if (!domain) return false;
  let normalized = String(domain).trim().toLowerCase();
  if (!normalized) return false;
  if (normalized.startsWith('@')) normalized = normalized.slice(1);
  return GENERIC_DOMAINS.has(normalized);
};
